import React, { useEffect } from 'react'
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'

// Layout
import UserLayout from '../components/user/UserLayout'

// User pages
import UserDashboard from '../pages/user/UserDashboard'
import MyPlayers from '../pages/user/MyPlayers'
import AddPlayer from '../pages/user/AddPlayer'
import MyProfile from '../pages/user/MyProfile'
import EditProfile from '../pages/user/EditProfile'
import PlayerDetail from '../pages/user/PlayerDetail'
import EditPlayer from '../pages/user/EditPlayer'
import MyEvents from '../pages/user/MyEvents'
import MyFixtures from '../pages/user/MyFixtures'
import MyScorers from '../pages/user/MyScorers'
import AllEvents from '../pages/user/AllEvents'
import TournamentParticipation from '../pages/user/TournamentParticipation'
import UserTournamentResult from '../pages/user/UserTournamentResult'
import UserNotifications from '../pages/user/UserNotifications'
import RequestMemberEdit from '../pages/user/RequestMemberEdit'
import UserSettings from '../pages/user/UserSettings'
import StateTournamentRecord from '../pages/user/StateTournamentRecord'
import UserCertificates from '../pages/user/UserCertificates'
import ForcePasswordReset from '../pages/user/ForcePasswordReset'

// Simple Protected Route Component
const ProtectedUserRoute = ({ children }) => {
  const navigate = useNavigate()
  const token = localStorage.getItem('tenant_admin_token')

  useEffect(() => {
    if (!token) {
      navigate('/user-login')
    }
  }, [token, navigate])

  if (!token) {
    return null
  }

  // Security: a reactivated user must reset their password before accessing anything.
  if (localStorage.getItem('force_password_reset') === '1') {
    return <ForcePasswordReset />
  }

  return <UserLayout>{children}</UserLayout>
}

const UserRoutes = () => {
  return (
    <Routes>
      <Route
        path="/dashboard"
        element={
          <ProtectedUserRoute>
            <UserDashboard />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/my-players"
        element={
          <ProtectedUserRoute>
            <MyPlayers />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/add-player"
        element={
          <ProtectedUserRoute>
            <AddPlayer />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedUserRoute>
            <MyProfile />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/edit-profile"
        element={
          <ProtectedUserRoute>
            <EditProfile />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/players/:playerId"
        element={
          <ProtectedUserRoute>
            <PlayerDetail />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/players/:playerId/edit"
        element={
          <ProtectedUserRoute>
            <EditPlayer />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/my-events"
        element={
          <ProtectedUserRoute>
            <MyEvents />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/events"
        element={
          <ProtectedUserRoute>
            <AllEvents />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/scorers"
        element={
          <ProtectedUserRoute>
            <MyScorers />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/fixtures"
        element={
          <ProtectedUserRoute>
            <MyFixtures />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/events/:eventId/participate"
        element={
          <ProtectedUserRoute>
            <TournamentParticipation />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/events/:eventId/results"
        element={
          <ProtectedUserRoute>
            <UserTournamentResult />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <ProtectedUserRoute>
            <UserNotifications />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedUserRoute>
            <UserSettings />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/request-edit/:memberId"
        element={
          <ProtectedUserRoute>
            <RequestMemberEdit />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/tournament-records"
        element={
          <ProtectedUserRoute>
            <StateTournamentRecord />
          </ProtectedUserRoute>
        }
      />
      <Route
        path="/certificates"
        element={
          <ProtectedUserRoute>
            <UserCertificates />
          </ProtectedUserRoute>
        }
      />
      <Route path="/" element={<Navigate to="/user/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/user/dashboard" replace />} />
    </Routes>
  )
}

export default UserRoutes
